/**
 * The Motorcity wordmark, served as the supplied artwork exactly — not redrawn
 * and not recoloured. It is the black lockup from the brand guideline, so every
 * surface it sits on in this app is light, including in dark mode.
 */
export function Logo({ className }: { className?: string }) {
  return <img src="/mc-logo.svg" alt="Motorcity" className={className} />;
}
